module.exports = {
  "version": "0.24.0"
};